/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown>, rule: NonNullable<unknown> }} Claim_Issue_OtherInputs */

const en_claim_issue_other = /** @type {(inputs: Claim_Issue_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field}: ${i?.rule}`)
};

/**
* | output |
* | --- |
* | "{field}: {rule}" |
*
* @param {Claim_Issue_OtherInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_issue_other = /** @type {((inputs: Claim_Issue_OtherInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Issue_OtherInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_issue_other(inputs)
});